// extracted by mini-css-extract-plugin
var _1 = "CustomerTransferSearchAndFilterBar-module__content-container";
var _2 = "CustomerTransferSearchAndFilterBar-module__input";
export { _1 as "content-container", _2 as "input" }
